<template>
  <main class="container-fluid">
    <div class="control d-flex align-items-center justify-content-between">
      <div class="pt-2">
        查詢資料{{ totalcusts }}筆
      </div>
      <a class="btn btn-default float-right m-0"
      @click="filterbarOpen = true">
        篩選
      </a>
    </div>
    <div v-if="listLoading && customerList.length ==0">
          <h3 class="mb-3">資料讀取中，請稍候...</h3>
    </div>
    <div v-else-if="customerList.length ==0 && !listLoading">
          <h3 class="mb-3">查無資料，請確認您輸入之資料是否正確</h3>
    </div>      
    <div v-if="customerList.length > 0" class="cards result">
      <div class="card"
      v-for="(item, tid) in customerList"
      :key="`result-item-${tid}`">
        <div class="row" style="word-break: break-all;">
          <div @click="toCustomer(item.id, item.serNo)" class="col-6">
            <h3>{{item.name}}</h3>
            <div class="meta">
              <span class="text-blue" v-if="item.sex==1">男</span>
              <span class="text-red" v-if="item.sex==2">女</span>
              {{item.birthday | ageCounter}} 歲
              <level :lv="Number(item.vip_level)" />
            </div>
          </div>
          <div class="col-6">
            <a class="item" :href="`tel:${item.phone}`" target="_blank">
              <div class="btn btn-sm btn-default float-left btn-icon"><i class="icon-telephone"></i></div>
              <div class="content">{{item.phone | emptyField}}</div>
            </a>
            <a class="item" :href="`tel:${item.mobile}`" target="_blank">
              <div class="btn btn-sm btn-default float-left btn-icon"><i class="icon-mobile"></i></div>
              <div class="content">{{item.mobile | emptyField}}</div>
            </a>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="card" >
        <div class="row" style="word-break: break-all;">
          <div class="col-12 text-center p-5">
            <div class="section-loading d-inline-block" style="height:20px; width:30px"></div> 資料讀取中 . . .
          </div>
        </div>
      </div>
    </div>  
    <div id="filter-sidebar" class="sidebar-menu right" :class="{'is-open': filterbarOpen}">
      <div class="sidebar-container">
        <header>
          <a class="close" @click="filterbarOpen=false"><i class="icon-close"></i></a>
          <h5>篩選</h5>
        </header>
        <main class="p-3">
          <form class="form">
            <div class="form-group">
              <label>客戶類型(可複選)</label>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s1" id="client-1"  @click="updateCustomer('s1')">
                <label for="client-1">壽險客戶</label>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s2" id="client-2"  @click="updateCustomer('s2')">
                <label for="client-2">產險客戶</label>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s3" id="client-3"  @click="updateCustomer('s3')">
                <label for="client-3">旅平險客戶</label>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s4" id="client-4"  @click="updateCustomer('s4')">
                <label for="client-4">房貸客戶</label>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s5" id="client-5"  @click="updateCustomer('s5')">
                <label for="client-5">團險客戶</label>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="csSource.s6" id="client-6"  @click="updateCustomer('s6')">
                <label for="client-6">準保戶</label>
              </div>                                                        
            </div>
          </form>
        </main>
        <footer>
          <button class="btn btn-default" @click="filterbarOpen=false">取消</button>
          <button class="btn btn-primary"  @click="initial()">套用</button>
        </footer>
      </div>
    </div>
  </main>
</template>

<script>
import {mapGetters, mapState,mapActions} from 'vuex'
import {commonMixin} from '../../mixins/common'
import Level from '../../components/Level'
import {getCustomers, setKeyWordLog} from '@/service'

export default {
  name: 'Index',
  mixins: [commonMixin],
  components: {
    Level
  },
  watch:{
    queryCustKeyword(){
      this.initial()
    }
  },
  computed: {
    ...mapGetters(['BaseUrl', 'QueryKeyword', 'UserInfo']),
    ...mapState(['queryCustKeyword']),
  },        
  data () {
    return {
      listLoading: false,
      checkCustomer:true, //預設全選
      filterbarOpen: false,
      totalcusts: '0',
      currentPage: '1',
      totalPage: '1',
      csSource:{
        s1:true,
        s2:true,
        s3:true,
        s4:true,
        s5:true,
        s6:true  
      },
      NewCsSource:{
        s1:'1',
        s2:'1',
        s3:'1',
        s4:'1',
        s5:'1',
        s6:'1'
      },
      customerList:[],
    }
  },
  methods: {
    ...mapActions(['updateCustID', 'updateSerNo']),  
    scrollmethod (scroll) {  //  滾動監聽
      // console.log(scroll)
      if (!this.listLoading && scroll > (document.body.offsetHeight - 700) && this.currentPage !== this.totalPage) {
        this.listLoading = true
        this.initial(this.currentPage - 0 + 1 + '')
      }
    },
    toCustomer (id, serNo) {
      // updata Vuex data
      if(id !== ''){
        this.updateCustID(id)
        this.updateSerNo('')
        localStorage.CustID = id
        localStorage.SerNo = ''
        this.$router.push({path: `/customer`})
      }else{
        this.updateSerNo(serNo)
        this.updateCustID('')
        localStorage.CustID = ''
        localStorage.SerNo = serNo
        this.$router.push({path: `/customer`})
      }
    },
    updateCustomer (name) {
      if(this.csSource[name]){
        this.NewCsSource[name] = 'N'
      }else{
        this.NewCsSource[name] = '1'
      }
      
    },
    initial(page = '1'){
        this.currentPage = page
        const vm = this
        let s1 = this.NewCsSource.s1
        let s2 = this.NewCsSource.s2
        let s3 = this.NewCsSource.s3
        let s4 = this.NewCsSource.s4
        let s5 = this.NewCsSource.s5
        let s6 = this.NewCsSource.s6

        //  如果不是滾動載入
        if(page == '1') {
          this.customerList = []
          setKeyWordLog(this.$store.state.userInfo.id,this.QueryKeyword) // 新增查詢關鍵字log
        }

        this.listLoading = true;
        getCustomers(this.$store.state.userInfo.id,this.QueryKeyword,s1,s2,s3,s4,s5,s6,page,'2','1','200').then(result => { // 取得客戶列表
          this.listLoading = false
          this.filterbarOpen = false 
          if(result.header && result.header.status == '200'){
            this.totalPage = result.body.totalpages
            this.totalcusts = result.body.totalcusts
            result.body.customer_list.forEach((customer) => {
              const data = {
                id : customer.id,
                name : customer.name,
                birthday : customer.birthday,
                sex : customer.sex,
                phone : customer.phone,
                mobile : customer.mobile,
                vip_level: Number(customer.vip_level) || 0,
                serNo: customer.ser_no || '',
              }
              this.customerList.push(data)
            })

            this.registerHanlink()
          }else{
            console.error('取得客戶列表 API 錯誤')
          } 
        })
    } ,
  },
  mounted() {
    this.initial()

    //  滾動監聽
    const vm = this
    document.addEventListener('scroll', this.scrollmethod)
    document.body.onscroll = () => {
      let scroll = document.scrollTop || document.body.scrollTop || document.scrollingElement.scrollTop || 0;
      let go = document.querySelector('#gotop')
      if( scroll > 300) {
        go.classList.add('is-show')
      } else {
        go.classList.remove('is-show')
      }
      vm.scrollmethod(scroll)
    }
  }
}
</script>
